import { render, staticRenderFns } from "./PoliciesDeleter.vue?vue&type=template&id=7abbdec4"
import script from "./PoliciesDeleter.vue?vue&type=script&lang=js"
export * from "./PoliciesDeleter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports